import { createStore } from 'vuex'
import {setCookie, getCookie, removeCookie} from "@/utils/userCookie"

export default createStore({
  state: {
  // 放置变量所用
    sidebarCollapsed: false,
    permission: null,
    userInfo: getCookie(),
    currentTab:'/',
    tabList:[]
  },
  getters: {
    getSidebarCollapsed: state => state.sidebarCollapsed,
    getPermission: state => state.permission
  },
  mutations: {
  // 获取set方法
    setSidebarCollapsed (state, val) {
      state.sidebarCollapsed = val
    },
    setPermission (state, val) {
      state.permission = val
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    logout(state) {
      state.userInfo = {
        userName: "",
        role: "",
        permissionCodes: ""
      }
    },
    updateCurrentTabState(state, current){
      state.currentTab = current
    },
    updateTabListState(state, current){
      let tabs = state.tabList;
      let tab = tabs.find(info=>info.path === current.path);
      if (!tab){
        tabs.push(current);
        if (tabs.length == 1) {
          tabs[0].closable = false;
        } else {
          tabs[0].closable = true;
        }
        state.tabList = tabs;
      }
    },
    removeCurrentTabState(state, key){
      let tabs = state.tabList;
      tabs.forEach((item,index) => {
        if (item.key === key){
          tabs.splice(index,1);
          if (state.currentTab === item.path) {
            let newIndex = index - 1;
            if (newIndex >= 0){
              let newTab = tabs[index-1];
              state.currentTab = newTab.path;
            }
          }
        }
      })
      if (tabs.length == 1) {
        tabs[0].closable = false;
      }
      state.tabList = tabs;
    }
  },
  actions: {
    setUserInfo({commit}, userInfo) {
      commit("setUserInfo", userInfo);
      setCookie(userInfo);
    },
    logout({commit}) {
      commit("logout");
      removeCookie();
    },
    updateCurrentTabState({commit}, current) {
      commit("updateCurrentTabState", current);
    },
    updateTabListState({commit}, current) {
      commit("updateTabListState", current);
    },
    removeCurrentTabState({commit}, key) {
      commit("removeCurrentTabState", key);
    }
  },
  modules: {
  }
})
